import type { FaxItem } from '../../services/faxItems';

/**
 * Who a fax came from: the physician when the number names one, with the
 * number underneath, and otherwise the number alone. A blank number means the
 * provider did not tell us, so it reads as unknown rather than withheld.
 */
export default function SenderLabel({ item }: { item: FaxItem }) {
  const number = item.fax_number_from?.trim() ? item.fax_number_from : null;
  if (!item.sender_physician_name) {
    return number ? (
      <>{number}</>
    ) : (
      <span className='text-muted-foreground'>Unknown</span>
    );
  }
  return (
    <div>
      <div className='font-medium'>{item.sender_physician_name}</div>
      <div className='text-xs text-muted-foreground'>
        {item.fax_number_from}
      </div>
    </div>
  );
}
